// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landing-page-banner-container {
    background: linear-gradient(180deg, #de7437 0%, #fbe4a8 100%);
}`, "",{"version":3,"sources":["webpack://./src/pages/landingPage/banner/webBanner/style.css"],"names":[],"mappings":"AAAA;IACI,6DAA6D;AACjE","sourcesContent":[".landing-page-banner-container {\n    background: linear-gradient(180deg, #de7437 0%, #fbe4a8 100%);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
